import * as React from "react"
import { PropsWithoutRef, useState } from "react"

import { BurgerMenu, NavBar, NavItem, NavLink } from "./styles"
import { Page } from "../../../hooks/use-navigation-data"
import { Glyphs } from "../icon"


export default function NavigationBarComponent(props: PropsWithoutRef<{ pages: Page[] }>) {
  const [menuOpen, setOpen] = useState(false)

  function toggleMenu(){
    setOpen(!menuOpen)
  }

  return (
    <>
      <BurgerMenu glyph={Glyphs.BurgerMenu} size={40} onClick={toggleMenu} />
      <NavBar open={menuOpen}>
        {props.pages.map(page => (
          <NavItem key={page.title}>
            <NavLink to={page.slug} activeClassName={"active"} onClick={toggleMenu}>{page.title}</NavLink>
          </NavItem>
        ))}
      </NavBar>
    </>
  )
}
